import { z } from 'zod';

import { idSchema } from './id';
import { skillShortSchema } from './skill';

import type { Mutation } from './common';

type SkillIdsField = {
    readonly skillIds: readonly string[];
};

export const educationHistoryItemSchema = z.object({
    id: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    degree: z.string(),
    description: z.string().optional(),
    fieldOfStudy: z.string(),
    ongoing: z.boolean().optional(),
    schoolName: z.string(),
    skills: skillShortSchema.array().optional(),
});

export const educationHistoryItemArraySchema = educationHistoryItemSchema.array();

export type EducationHistoryItem = z.infer<typeof educationHistoryItemSchema>;

export const educationHistoryCreationSchema = educationHistoryItemSchema
    .omit({ id: true, skills: true })
    .extend({ skillIds: idSchema.array().optional() });
export type EducationHistoryCreation = z.infer<typeof educationHistoryCreationSchema>;

export type EducationHistoryMutation = Mutation<EducationHistoryItem> &
    Pick<EducationHistoryItem, 'degree' | 'fieldOfStudy' | 'id' | 'schoolName'> &
    SkillIdsField;
